<style lang="scss" scoped>
.panel {
	text-align: center;
	font-size: 18px;
	& span {
		color: #3d85ff;
		font-weight: bold;
		cursor: pointer;
	}
}
p {
	margin: -20px 0 15px 0;
	font-size: 16px;
}
</style>

<template lang="pug">
    div
        panel.panel Can't find the application you are looking for? <span @click="toggleDialog">Register your interest in a different application</span>.
        el-dialog(title="Request an application", :visible.sync="dialog", width="20%")
            p If you haven’t seen the application you are looking for, please fill in the form below to let us know.
            p Please provide details for the application (i.e. the name and webpage) and one of the Wonde team will be in touch shortly.
            el-form(ref="form", :model="form", :rules="rules", label-position="top")
                el-form-item(label="Full name", prop="name")
                    el-input(v-model="form.name")
                el-form-item(label="Email address", prop="emailAddress")
                    el-input(v-model="form.emailAddress")
                el-form-item(label="School / Organisation", prop="school")
                    el-input(v-model="form.school")
                el-form-item(label="App Name", prop="appName")
                    el-input(v-model="form.appName")
                el-form-item(label="App URL / Webpage", prop="appUrl")
                    el-input(v-model="form.appUrl")
                el-form-item(label="Message / Additional Details ", prop="message")
                    el-input(v-model="form.message", type="textarea", :autosize="{ minRows: 3, maxRows: 7 }")
            span(slot="footer", class="dialog-footer")
                el-button(:loading="loading", @click="toggleDialog") Cancel
                el-button(:loading="loading", type="primary", native-type="submit", @click.prevent="submit") Submit
</template>

<script>
import gql from "graphql-tag";

export default {
	data() {
		return {
			loading: false,
			dialog: false,
			rules: {
				name: [{ required: true, message: "Please enter your name", trigger: "blur" }],
				emailAddress: [
					{ required: true, message: "Please enter an email address", trigger: "blur" },
					{ type: "email", message: "Please enter a valid email address", trigger: "blur" }
				],
				appName: [{ required: true, message: "Please enter your message", trigger: "blur" }],
				appUrl: [{ required: true, message: "Please enter your message", trigger: "blur" }]
			},
			form: this.clearForm()
		};
	},
	methods: {
		clearForm() {
			return {
				name: "",
				emailAddress: "",
				school: "",
				appName: "",
				appUrl: "",
				message: ""
			};
		},
		toggleDialog() {
			this.dialog = !this.dialog;

			this.form = this.clearForm();
		},
		async submit() {
			try {
				await this.$refs.form.validate();

				this.loading = true;

				const {
					data: { RequestNewApplication: res }
				} = await this.$apollo.mutate({
					mutation: gql`
						mutation RequestNewApplication(
							$name: String!
							$emailAddress: String!
							$school: String
							$appName: String!
							$appUrl: String!
							$message: String
						) {
							RequestNewApplication(
								name: $name
								emailAddress: $emailAddress
								school: $school
								appName: $appName
								appUrl: $appUrl
								message: $message
							)
						}
					`,
					variables: {
						name: this.form.name,
						emailAddress: this.form.emailAddress,
						school: this.form.school,
						appName: this.form.appName,
						appUrl: this.form.appUrl,
						message: this.form.message
					}
				});

				if (!res) {
					throw Error();
				}

				this.toggleDialog();
				this.$message.success("Your request has been submitted.");
			} catch (e) {
				switch (e.message) {
					default:
						console.log("e.message", e.message);
						this.$message.error("Something went wrong, please contact support.");
						break;
				}
			}

			this.loading = false;
		}
	}
};
</script>